<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.payment_option") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-sync"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getList()"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(rowspan=2 width="3%")
                          span #
                        th(rowspan=2 width="10%")
                          span(:title="$t('ui.payment_mode')" ) {{ $t('ui.payment_mode') }}
                        th(rowspan=2 width="10%")
                          span(:title="$t('ui.payment_desc')" ) {{ $t('ui.payment_desc') }}                        
                        th.text-center(rowspan=2 width="5%")
                          span(:title="$t('ui.status')" ) {{ $t('ui.status') }}
                        th.text-center(rowspan=2 width="10%")
                          span(:title="$t('ui.sequence')" ) {{ $t('ui.sequence') }} 
                        th.text-center(colspan=3 width="45%")
                          span(:title="$t('ui.settings')" ) {{ $t('ui.settings') }}
                        th.text-center(rowspan=2 width="5%")
                          span(:title="$t('ui.action')" ) {{ $t('ui.action') }}
                      tr
                        th
                          span.text-left {{ $t('ui.callback') }}
                        th
                          span.text-left {{ $t('ui.api') }}
                        th
                          span.text-left {{ $t('ui.prefix') }}
                    tbody.clusterize-content
                      tr(v-if="list.length == 0")
                        td(:colspan="isEditAccess ? 9 : 8").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in list")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.payment_mode") {{ item.payment_mode }}
                        td
                          span(:title="item.payment_desc") {{ item.payment_desc }}                                               
                        td.text-center
                          .d-flex.justify-content-center.align-items-center(v-if="!['MANUAL'].includes(item.payment_mode)")
                            //- label.custom-switch
                            //-   input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" disabled)
                            //-   span.custom-switch-indicator
                            label.custom-switch
                              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="isEditAccess ? changedStatus(item, $event) : null" :disabled="!isEditAccess")
                              span.custom-switch-indicator
                        td.text-center
                          b-form-select.text-center(v-if="!['MANUAL'].includes(item.payment_mode)" v-model="item.seq" @change="isEditAccess ? changedProviderSeq(item, $event) : null" size="sm" :disabled="!isEditAccess")
                            option(value=0 disabled) 0
                            option(v-for="index in list.length" :key="index") {{ index }}
                            option(v-if="listLength < 100" :key="100") 100
                        td
                          table.small.w-100(v-if="!['MANUAL'].includes(item.payment_mode)")
                            td.w-10
                              tr.font-weight-bold {{ $t('ui.deposit') }}
                              tr.font-weight-bold {{ $t('ui.withdrawal') }}
                              tr.font-weight-bold {{ $t('ui.affiliate') }}
                              //- tr.font-weight-bold {{ $t('ui.free_credit') }}
                            td
                              tr.ellipsis(:title="item.url_callback_d") {{ item.url_callback_d }}
                              tr.ellipsis(:title="item.url_callback_w") {{ item.url_callback_w }}
                              tr.ellipsis(:title="item.url_callback_aff") {{ item.url_callback_aff }}
                              //- tr.ellipsis(:title="item.url_callback_fc") {{ item.url_callback_fc }}
                        td
                          table.small.w-100(v-if="!['MANUAL'].includes(item.payment_mode)")
                            td
                              tr.font-weight-bold {{ $t('ui.deposit') }}
                              tr.font-weight-bold {{ $t('ui.withdrawal') }}
                              tr.font-weight-bold {{ $t('ui.balance') }}
                            td
                              tr.ellipsis(:title="item.url_api_d") {{ item.url_api_d }}
                              tr.ellipsis(:title="item.url_api_w") {{ item.url_api_w }}
                              tr.ellipsis(:title="item.url_api_bal") {{ item.url_api_bal }}
                        td
                          table.small.w-100(v-if="!['MANUAL'].includes(item.payment_mode)")
                            td
                              tr.font-weight-bold {{ $t('ui.deposit') }}
                              tr.font-weight-bold {{ $t('ui.withdrawal') }}
                              tr.font-weight-bold {{ $t('ui.affiliate') }}
                              tr.font-weight-bold {{ $t('ui.delimiter') }} 
                              //- tr.font-weight-bold {{ $t('ui.free_credit') }} 
                            td
                              tr(:title="item.prefix_d") {{ item.prefix_d }}
                              tr(:title="item.prefix_w") {{ item.prefix_w }}
                              tr(:title="item.prefix_aff") {{ item.prefix_aff }}
                              tr(:title="item.prefix_delimiter") {{ item.prefix_delimiter }}
                              //- tr(:title="item.prefix_fc") {{ item.prefix_fc }}
                        td.text-center 
                          template(v-if="isEditAccess && !['MANUAL'].includes(item.payment_mode)")
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-info(href="javascript:void(0)" @click="onEditUrl(item)" :title="$t('ui.edit')") 


      paymentoptionupdate(ref="paymentoptionupdate" :item="selectedPayment" @clicked="afterPaymentOptionUpdate" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import paymentoptionupdate from "@/components/setup/paymentOptionUpdate.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    paymentoptionupdate,
  },
  data: () => ({
    loading: false, 
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    list: [],
    selectedPayment: null,
    maxSeq: 0
  }),
  computed: {
    isEditAccess() {
      return this.$helpers.showActionButton("e_paymentoption");
    },
    listLength() {
      if (this.list) {
        if(this.maxSeq > this.list.length) {
          return this.maxSeq;
        } else {
          return this.list.length;
        }
      } else {
        return 0;
      }
    },

  },
  mounted: function() {
    this.getList();
  },
  methods: {
    changedProviderSeq: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_payment_mode_seq_confirm", { mode: item.payment_mode }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmProviderSeq(item, eventStatus);
          } else {
            this.getList();
            // eventStatus.srcElement.value = item.seq;
          }
        });
    },
    confirmProviderSeq: function(item, seq) {
      let url = config.paymentOptionGbUpdateSeqUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        payment_mode: item.payment_mode,
        seq: seq,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getList: function() {
      let url = config.paymentOptionGlobalListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.list = response.data.dt;
                if(this.list.length > 0) {
                  // Filter out objects with seq < 100, then find the max seq value
                  const maxSeq = this.list
                      .filter(item => item.seq < 100) // Keep only items with seq < 100
                      .reduce((max, item) => Math.max(max, item.seq), -Infinity); // Find the maximum seq

                  this.maxSeq = maxSeq;
                } else {
                  this.maxSeq = 0;
                }

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onEditUrl(e) {
      this.selectedPayment = e;
      this.$refs.paymentoptionupdate.$refs.paymentOptionUpdate.show();
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_payment_mode_status_confirm", { name: item.payment_mode }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.paymentOptionGbUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        payment_mode: item.payment_mode,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterPaymentOptionUpdate: function() {
      this.getList();
      this.$helpers.showDialog(this.$t("ui.combine.payment_option_callback_update"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>

<style lang="scss" scoped>
.ellipsis {
  display: inline-block;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}
</style>